import { render } from "./TestimonialsPage.vue?vue&type=template&id=2d107310"
import script from "./TestimonialsPage.vue?vue&type=script&lang=js"
export * from "./TestimonialsPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__